/* eslint-disable import/no-unresolved */
import { Button } from "@mui/material";
import { memo, ReactNode } from "react";
import StorageService from "src/utils/Storage/storageService";
import { hideToEditMEFButton } from "src/helpers/FormDetails/CreateDetails/interfaces";
import CustomBoxModal from "../CustomModalBox";

interface Props {
  text: ReactNode;
  onCancel: () => void;
  onNext: () => void;
}
function CustomConfirmationModal({ text, onCancel, onNext }: Props) {
  const loggedInUser = StorageService.getFromLocalStorage("user");

  return (
    <CustomBoxModal>
      <div className="my-6">
        <div className="text-center my-3 mx-6.25 text-black font-semibold text-lg leading-170">
          {text}
        </div>
        <div className="flex space-x-5 justify-center mt-8 md:pl-5 md:pr-5">
          <Button
            variant="contained"
            onClick={onCancel}
            className="!uppercase h-14 md:w-52 w-32 !rounded-xl"
          >
            Go to dashboard
          </Button>
          {hideToEditMEFButton(loggedInUser?.role) && (
            <Button
              onClick={onNext}
              variant="contained"
              className="!uppercase h-14 md:w-52 w-32 !rounded-xl "
            >
              Edit MEF form
            </Button>
          )}
        </div>
      </div>
    </CustomBoxModal>
  );
}

export default memo(CustomConfirmationModal);
